import React, { useEffect, useState } from "react";
import api from "../../api/axiosConfig";
import { AiOutlineSend } from "react-icons/ai";

const StatusTimeline = ({
  todoId,
  selectedTodoName,
  userId,
  status,
  fetchHistory,
  setFetchHistory,
}) => {
  const [history, setHistory] = useState([]);
  const [message, setMessage] = useState("");
  const [expandedStatuses, setExpandedStatuses] = useState({});

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await api.get(`/api/todolists/${todoId}/history`);
        const reversed = response.data.reverse();
        const grouped = groupForwardedStatuses(reversed);
        setHistory(grouped);
        setFetchHistory(false);
      } catch (error) {
        console.error("Error fetching history:", error);
      }
    };
    fetchHistory();
  }, [todoId, fetchHistory]);

  const groupForwardedStatuses = (historyData) => {
    const groupedHistory = [];
    for (let i = 0; i < historyData.length; i++) {
      const current = historyData[i];
      const next = historyData[i + 1];

      if (
        current.status === "forwardedto" &&
        next &&
        next.status === "forwarded" &&
        current.changed_at === next.changed_at
      ) {
        groupedHistory.push({
          status: "forwardedGroup",
          entries: [next, current],
          changed_at: current.changed_at,
        });
        i++; // skip next since grouped
      } else {
        groupedHistory.push(current);
      }
    }
    return groupedHistory;
  };

  const sendMessage = async () => {
    if (message.trim() === "") return;
    try {
      const response = await api.post(`/api/todolist/${todoId}/chat`, {
        user_id: userId,
        message,
      });
      if (response.data.success) {
        setMessage("");
        const updated = await api.get(`/api/todolists/${todoId}/history`);
        const grouped = groupForwardedStatuses(updated.data.reverse());
        setHistory(grouped);
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const toggleShowMore = (index) => {
    setExpandedStatuses((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const markAsRead = async () => {
    try {
      await api.patch(`/api/todolist/${todoId}/chat/read`, {
        user_id: userId,
      });
    } catch (error) {
      console.error("Error marking messages as read:", error);
    }
  };

  useEffect(() => {
    markAsRead();
  }, [todoId, userId]);
  // Outside the component
  const parseMessageWithLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#007bff",
              textDecoration: "underline",
              fontSize: "12px",
              backgroundColor: "transparent",
            }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="timeline-container">
      <h3 className="timeline-title">Ticket #{selectedTodoName} Timeline</h3>
      <div className="timeline">
        {history.map((entry, index) => {
          const isGroup = entry.status === "forwardedGroup";
          const isLast = index === 0;
          const messagesToShow = expandedStatuses[index]
            ? entry.messages
            : entry.messages?.slice(0, 2);

          return (
            <div key={index} className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <p className="status-text">
                  {isGroup
                    ? "Forwarded"
                    : entry.status.charAt(0).toUpperCase() +
                      entry.status.slice(1)}
                </p>

                {isGroup ? (
                  <>
                    {entry.entries.map((sub, i) => (
                      <div key={i} style={{ backgroundColor: "transparent" }}>
                        <p className="changed-by">
                          {sub.dp && sub.dp !== "null" && (
                            <img
                              className="todo-dp"
                              src={
                                sub.dp
                                  ? `${api.defaults.baseURL}${sub.dp}`
                                  : "/default-avatar.png"
                              }
                              alt="profile"
                            />
                          )}
                          <div
                            style={{
                              marginTop: "4px",
                              marginLeft: "4px",
                              backgroundColor: "transparent",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "normal",
                                backgroundColor: "transparent",
                                marginTop: "4px",
                                marginLeft: "4px",
                              }}
                            >
                              {sub.status === "forwardedto" ? "to" : "by"}&nbsp;
                            </span>
                            <span
                              style={{
                                backgroundColor: "transparent",
                                marginTop: "4px",
                              }}
                            >
                              {sub.changed_by}-{sub.changed_by_emp}
                            </span>
                          </div>
                        </p>

                        {/* ✅ Messages under forwardedto */}
                        {sub.status === "forwardedto" &&
                          sub.messages?.length > 0 && (
                            <div className="chat-messages">
                              {(expandedStatuses[index]
                                ? sub.messages
                                : sub.messages.slice(0, 2)
                              ).map((msg, mi) => (
                                <div
                                  key={mi}
                                  className="chat-message"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between",
                                    backgroundColor: "transparent",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      backgroundColor: "transparent",
                                      width: "18vw",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    {msg.dp && msg.dp !== "null" && (
                                      <img
                                        className="todo-dp"
                                        src={
                                          msg.dp
                                            ? `${api.defaults.baseURL}${msg.dp}`
                                            : "/default-avatar.png"
                                        }
                                        alt="profile"
                                      />
                                    )}
                                    <strong
                                      style={{
                                        fontSize: "12px",
                                        backgroundColor: "transparent",
                                        display: "flex",
                                        textWrap: "nowrap",
                                      }}
                                    >
                                      {msg.sender_name}-{msg.employeecode}:
                                    </strong>
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        backgroundColor: "transparent",
                                        wordBreak: "break-word",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      {parseMessageWithLinks(msg.message)}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "8px",
                                      color: "#777",
                                      backgroundColor: "transparent",
                                      width: "4.5vw",
                                    }}
                                  >
                                    {new Date(msg.created_at).toLocaleString(
                                      "en-GB",
                                      {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      }
                                    )}
                                  </div>
                                </div>
                              ))}

                              {/* Show more / Show less */}
                              {sub.messages.length > 2 && (
                                <div
                                  style={{
                                    color: "#007bff",
                                    cursor: "pointer",
                                    marginTop: "5px",
                                    fontSize: "12px",
                                    backgroundColor: "transparent",
                                  }}
                                  onClick={() => toggleShowMore(index)}
                                >
                                  {expandedStatuses[index]
                                    ? "Show less..."
                                    : "Show more..."}
                                </div>
                              )}
                            </div>
                          )}
                      </div>
                    ))}
                  </>
                ) : (
                  <p className="changed-by">
                    {entry.dp && entry.dp !== "null" && (
                      <img
                        className="todo-dp"
                        src={
                          entry.dp
                            ? `${api.defaults.baseURL}${entry.dp}`
                            : "/default-avatar.png"
                        }
                        alt="profile"
                      />
                    )}
                    <div
                      style={{
                        marginTop: "4px",
                        marginLeft: "4px",
                        backgroundColor: "transparent",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "normal",
                          backgroundColor: "transparent",
                        }}
                      >
                        by
                      </span>
                      <span
                        style={{
                          marginLeft: "2px",
                          backgroundColor: "transparent",
                        }}
                      >
                        {entry.changed_by}-{entry.changed_by_emp}
                      </span>
                    </div>
                  </p>
                )}

                <p className="changed-at">
                  {new Date(entry.changed_at).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>

                {entry.messages && entry.messages.length > 0 && (
                  <div className="chat-messages">
                    {messagesToShow.map((msg, i) => (
                      <div
                        key={i}
                        className="chat-message"
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "space-between",
                          backgroundColor: "transparent",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: "transparent",
                            width: "18vw",
                          }}
                        >
                          {msg.dp && msg.dp !== "null" && (
                            <img
                              className="todo-dp"
                              src={
                                msg.dp
                                  ? `${api.defaults.baseURL}${msg.dp}`
                                  : "/default-avatar.png"
                              }
                              alt="profile"
                            />
                          )}
                          <strong
                            style={{
                              fontSize: "12px",
                              backgroundColor: "transparent",
                              display: "flex",
                              marginLeft: "4px",
                              marginTop: "4px",
                              textWrap: "nowrap",
                            }}
                          >
                            {msg.sender_name}-{msg.employeecode}:
                          </strong>{" "}
                          <span
                            style={{
                              fontSize: "12px",
                              backgroundColor: "transparent",
                              wordBreak: "break-word",
                              marginTop: "4px",
                              marginLeft: "4px",
                            }}
                          >
                            {parseMessageWithLinks(msg.message)}
                          </span>
                        </div>
                        <div
                          style={{
                            fontSize: "8px",
                            color: "#777",
                            backgroundColor: "transparent",
                            width: "4.5vw",
                          }}
                        >
                          {new Date(msg.created_at).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </div>
                      </div>
                    ))}
                    {entry.messages.length > 2 && (
                      <div
                        style={{
                          color: "#007bff",
                          cursor: "pointer",
                          marginTop: "5px",
                          fontSize: "12px",
                          backgroundColor: "transparent",
                        }}
                        onClick={() => toggleShowMore(index)}
                      >
                        {expandedStatuses[index]
                          ? "Show less..."
                          : "Show more..."}
                      </div>
                    )}
                  </div>
                )}

                {isLast && status !== "withdrawn" && status !== "closed" && (
                  <form
                    className="chat-input"
                    onSubmit={(e) => {
                      e.preventDefault();
                      sendMessage();
                    }}
                  >
                    <input
                      type="text"
                      className="send-message-input"
                      value={message}
                      placeholder="Type a message(Max 200 characters)..."
                      onChange={(e) => setMessage(e.target.value)}
                      maxLength={200}
                    />
                    <button
                      type="submit"
                      style={{ border: "none", cursor: "pointer" }}
                    >
                      <AiOutlineSend
                        style={{ backgroundColor: "transparent" }}
                      />
                    </button>
                  </form>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatusTimeline;
